import './App.sass';
import { ChatBot } from './ChatBot';
import Header from './Header';
import { useAtom } from 'jotai'
import { requestsAtom } from "./State";
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ResourceDetails } from './ResourceDetails';
import MapView from './MapView';


interface Properties {
  tenant?: string;
}

export default function ChatBotPage(properties: Properties) {
  const [requests] = useAtom(requestsAtom) as any;
  const [selectedResource, setSelectedResource] = useState(null) as any;

  const resourceSelected = (resource: any) => {
    console.log('======> resourceSelected', resource);
    setSelectedResource(resource);
  }

  return (
    <>
      {selectedResource
        ?
        <MapView resource={selectedResource} resetResource={() => setSelectedResource(null)}></MapView>
        :
        <div className="App">
          <Header showSidePanel={!properties.tenant} showMapItem={!properties.tenant} showLogo={requests && requests.length > 0}></Header>
          <ChatBot selectedResource={selectedResource} resourceSelected={resourceSelected}>
          </ChatBot>
        </div>
      }
    </>
  );
}
